module.exports = "<div class=\"categoryHeaderBanners\">\r\n    <wow-banner\r\n        banner=\"banner\"\r\n        ng-repeat=\"banner in $ctrl.bannersService.banners[$ctrl.category.NodeId] track by banner.ID\">\r\n    </wow-banner>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/shop/header/category-header-banners.component.html
// module id = 415
// module chunks = 0